module.exports = __webpack_public_path__ + "media/images/alteryx-homepage-new-ba6ea561b2c3f0f1747e14ce70785001191b9561868f93255613bfec8d821456.png";